import { Button, Icon, Input, InputProps } from '@chakra-ui/react';
import { BiUpload } from 'react-icons/bi';

export const FileInput = (props: InputProps) => {
    return (
        <Button
            as="label"
            colorScheme="teal"
            variant="outline"
            size="sm"
            leftIcon={<Icon as={BiUpload} />}
            cursor="pointer"
        >
            <Input
                display="none"
                type="file"
                onClick={(ev: any) => {
                    ev.target.value = '';
                }}
                {...props}
            />
            Upload CSV
        </Button>
    );
};
